import { defineStore } from 'pinia';
import { clone } from 'lodash-es';
import UserApi from '@/sheep/api/member/user';

// 默认用户信息
const defaultUserInfo = {
  avatar: '', // 头像
  nickname: '', // 昵称
  gender: 0, // 性别
  mobile: '', // 手机号
  point: 0, // 积分
};

const user = defineStore({
  id: 'user',
  state: () => ({
    userInfo: clone(defaultUserInfo), // 用户信息
    isLogin: !!uni.getStorageSync('token'), // 登录状态
  }),

  actions: {
    // 获取用户信息
    async getInfo() {
      // 暂不调用用户信息接口
      const { code, data } = await UserApi.userGetInfo();
      if (code !== 0) {
        return;
      }
      this.userInfo = data;
      return Promise.resolve(data);
    },

    // 设置 token
    setToken(token = '', refreshToken = '') {
      if (token === '') {
        this.isLogin = false;
        uni.removeStorageSync('token');
        uni.removeStorageSync('refresh-token');
      } else {
        this.isLogin = true;
        uni.setStorageSync('token', token);
        uni.setStorageSync('refresh-token', refreshToken);
        // 登录后不自动获取用户信息
        this.loginAfter();
      }
      return this.isLogin;
    },

    // 重置用户默认数据
    resetUserData() {
      // 清空 token
      this.isLogin = false;
      uni.removeStorageSync('token');
      uni.removeStorageSync('refresh-token');
      // 清空用户相关的缓存
      this.userInfo = clone(defaultUserInfo);
    },

    // 登录后，加载用户信息
    async loginAfter() {
      await this.getInfo();
    },

    // 登出系统
    async logout() {
      this.resetUserData();
      return !this.isLogin;
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'user-store',
      },
    ],
  },
});

export default user;
